'use client';

import { useCallback, useContext } from 'react';

import { LabelContext } from './context';

export function useTranslate(namespace?: string) {
    const messages = useContext(LabelContext);

    return useCallback(
        (key: string, defaultValue?: string) => {
            const mergedKey = namespace ? `${namespace}.${key}` : key;

            return messages?.[mergedKey] ?? defaultValue ?? `[${mergedKey}]`;
        },
        [messages, namespace]
    );
}
